import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.white,
  iconColor: colors.neonPurple,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.slateGrey,
  textColorLight: colors.white
};
export default accordion;